import { useState } from "react";
import { useTranslation } from "react-i18next";
import { ScanFace } from "lucide-react";
import { toast } from "sonner";
import { NeuButton, NeuCard } from "../../components/neu/Neu";
import { BIOMETRIC_ITEM } from "./consentItems";
import { ConsentRow } from "./ConsentRow";

// موافقة بيومترية صريحة ومنفصلة قبل أي فتح للكاميرا (GDPR Art.9 / BIPA / آبل 5.1.2).
export const BiometricGate = ({ open, onAccept, onClose }) => {
  const { t } = useTranslation();
  const [checked, setChecked] = useState(false);
  const [busy, setBusy] = useState(false);
  if (!open) return null;

  const submit = async () => {
    setBusy(true);
    try {
      await onAccept();
    } catch {
      toast.error(t("errors.generic"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 px-5 py-8" data-testid="biometric-gate">
      <NeuCard className="animate-pop w-full max-w-md p-6">
        <div className="flex items-center gap-3">
          <ScanFace className="h-6 w-6 text-primary" />
          <p className="text-lg font-black">{t("consent.bioTitle")}</p>
        </div>
        <p className="mt-3 text-xs leading-6 text-muted-foreground">{t("consent.bioIntro")}</p>
        <ul className="mt-3 grid gap-1 text-xs leading-6 text-muted-foreground">
          <li>• {t("consent.bioWhat")}</li>
          <li>• {t("consent.bioPurpose")}</li>
          <li>• {t("consent.bioRetention")}</li>
          <li>• {t("consent.bioProcessor")}</li>
          <li>• {t("consent.bioWithdraw")}</li>
        </ul>
        <div className="mt-4">
          <ConsentRow
            id="biometric"
            checked={checked}
            onChange={setChecked}
            label={t(BIOMETRIC_ITEM.label)}
            hint={t(BIOMETRIC_ITEM.hint)}
            to={BIOMETRIC_ITEM.to}
            linkLabel={t(BIOMETRIC_ITEM.link)}
          />
        </div>
        <div className="mt-5 flex gap-2">
          <NeuButton variant="primary" className="flex-1 py-3" data-testid="biometric-gate-accept"
            disabled={!checked || busy} onClick={submit}>
            {busy ? t("app.loading") : t("consent.bioAccept")}
          </NeuButton>
          <NeuButton className="px-5 py-3" data-testid="biometric-gate-decline" onClick={onClose}>
            {t("consent.bioDecline")}
          </NeuButton>
        </div>
      </NeuCard>
    </div>
  );
};
